class TrFacetsDrawerState extends HTMLElement {
  selectors = {
    drawerToggle: '[data-tr-js-facets-drawer-toggle]',
    drawerDetail: '[data-tr-js-facets-drawer-detail]',
  };

  connectedCallback() {
    this.drawerToggleElement = this.closest('menu-drawer')?.querySelector(this.selectors.drawerToggle);
    this.drawerDetailElements = this.closest('menu-drawer')?.querySelectorAll(this.selectors.drawerDetail);

    this.init();
    this.bindEvents();
  }

  disconnectedCallback() {
    this.destroy();
  }

  init() {
    this.syncDetails();
  }

  bindEvents() {
    if (!this.drawerToggleElement) return;

    this.observer = new MutationObserver(this.syncDetails);
    this.observer.observe(this.drawerToggleElement, {
      attributes: true,
      attributeFilter: ['class', 'open'],
    });
  }

  syncDetails = () => {
    const isDrawerOpen = this.drawerToggleElement?.open && this.drawerToggleElement.classList.contains('menu-opening');

    if (!isDrawerOpen) return;

    this.drawerDetailElements?.forEach((drawerDetailElement) => {
      drawerDetailElement.open = true;
    });
  };

  destroy() {
    this.observer?.disconnect();
  }
}

customElements.define('tr-facets-drawer-state', TrFacetsDrawerState);
